import { AdditionalServicesAvailability } from '@notino/web-tracking';

import { useEngravingTryItFirstContext } from '@containers/ProductDetailContainer/ProductDetail/ProductBaseInfo/context/EngravingTryItFirst';
import { useTryItFirstCampaigns } from '@containers/ProductDetailContainer/ProductDetail/ProductBaseInfo/hooks/useTryItFirstCampaigns';
import { useProductDetailContext } from '@containers/ProductDetailContainer/ProductDetailContext';
import { useFeatureFlags } from '@context/featureFlags/FeatureFlagsProvider';

export const useShowTryItFirst = (recommendedVariantId: string) => {
  const { product, tryItFirstAvailable } = useProductDetailContext();
  const { shade_finder_try_it_first_product_master_ids } = useFeatureFlags();
  const tryItFirstCampaigns = useTryItFirstCampaigns(product.campaigns);

  const {
    state: { withEngraving },
  } = useEngravingTryItFirstContext();

  const hasCampaign = tryItFirstCampaigns.find(
    (campaign) => campaign.productId === recommendedVariantId
  );

  return (
    shade_finder_try_it_first_product_master_ids?.includes(
      product.webMasterId
    ) &&
    hasCampaign &&
    !withEngraving &&
    tryItFirstAvailable === AdditionalServicesAvailability.available
  );
};
